import { isNilOrEmpty } from '../../value/isNilOrEmpty';
/**
 * Returns true if all value in {args} match the {check}
 *
 * @since v2.27.0
 * @category Logic
 * @template {T} - The type of value
 * @param {(value: T) => boolean} check - The condition to check for a match
 * @param {T[]} args - The values to check
 * @returns {boolean}
 * @example
 * all(value => value > 5, 25, 7) //=> true
 * all(value => value > 10, 25, 7) //=> false
 * @docgen_example
 * all(value => value > 5, 25, 7);
 */
export var all = function (check) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    if (isNilOrEmpty(args))
        return false;
    for (var _a = 0, args_1 = args; _a < args_1.length; _a++) {
        var value = args_1[_a];
        if (!check(value))
            return false;
    }
    return true;
};
